import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';
import React from 'react';
import { appTheme } from './theme';
export var ThemeProvider = function (_a) {
    var children = _a.children;
    return (_jsxs(MuiThemeProvider, { theme: appTheme, children: [_jsx(CssBaseline, {}), children] }));
};
